import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { BrandAssetContent } from "../types";
import { DEFAULT_LOGO_HEIGHT, PARAM_LOGO_HEIGHT_KEY } from "../constants";

interface ParametersPanelProps {
  parameters: BrandAssetContent["parameters"];
}

const ParametersPanel: React.FC<ParametersPanelProps> = ({ parameters }) => {
  const { t } = useTranslation(["corporate-brand-asset"]);
  const extraKeys = Object.keys(parameters).filter(
    (k) => k !== PARAM_LOGO_HEIGHT_KEY,
  );

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            type="number"
            size="small"
            fullWidth
            label={t("parameters.logoHeight")}
            value={parameters[PARAM_LOGO_HEIGHT_KEY] ?? DEFAULT_LOGO_HEIGHT}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>
        {extraKeys.map((key) => (
          <Grid item xs={12} sm={6} key={key}>
            <TextField
              size="small"
              fullWidth
              label={key}
              value={String(parameters[key] ?? "")}
              InputProps={{ readOnly: true }}
              disabled
            />
          </Grid>
        ))}
      </Grid>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mt: 1, display: "block" }}
      >
        {t("parameters.hint")}
      </Typography>
    </Box>
  );
};

export default ParametersPanel;
